import React from "react";
import PhotoUploader from "./PhotoUploader";
import { useTranslation } from "react-i18next";
export default function ProfileHeader({
    data,
    onPhotoChange
}) {

    const { t } = useTranslation();

    const formatDate = (date) => {
        if (!date) return "";
        return new Date(date).toLocaleDateString(
            "fr-FR"
        );

    };

    const getBadgeClass = () => {

        if (!data.statutId)
            return "bg-secondary";
        switch (Number(data.statutId)) {
            case 1:
                return "bg-success";
            case 2:
                return "bg-primary";

            case 3:
                return "bg-warning text-dark";

            case 4:
                return "bg-danger";

            default:
                return "bg-secondary";
        }

    };

    return (

        <div className="profile-header card border-0 shadow rounded-4 mb-4">
            <div className="card-body">
                <div className="row align-items-center">
                    {/* PHOTO */}
                    <div className="col-lg-3 text-center">

 <PhotoUploader
    id={data.id}
    imageUrl={data.imageUrl}
    onUpload={onPhotoChange}
/>

                    </div>
                    {/* INFOS */}
                    <div className="col-lg-9">
                        <h2 className="profile-name">
                            {data.fullName || "Nom non renseigné"}
                        </h2>
                        <div className="profile-email">
                            <i className="bi bi-envelope-fill me-2"></i>
                            {data.email}
                        </div>
                        <div className="mt-3">
                            <span className={`badge rounded-pill ${getBadgeClass()} fs-6`}>
                                <i className="bi bi-person-badge me-2"></i>
                                {t("monProfile.header")}
                            </span>
                        </div>
                        <div className="mt-3 text-muted">
                            <i className="bi bi-calendar-event me-2"></i>
                           {t("monProfile.activiteStartDate")}
                        
                            {" "}
                            {formatDate(data.dateStartActv)}
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}